var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/** @file This file contains plagiarism related models. */
import { plagiarism } from '@codegrade/documents';
import * as models from '@/models';
import { CacheDecorator } from '@/utils/cache';
/** An extended `PlagiarismCase` model. */
export class PlagiarismCase extends plagiarism.PlagiarismCase {
    constructor() {
        super(...arguments);
        /** Cache for computed properties. */
        this._cache = new CacheDecorator();
    }
    /** @returns The models from the store for the users connected to this case. */
    get storeUsers() {
        return this.users.map(user => {
            if (user == null) {
                return null;
            }
            return models.User.findUserById(user.id);
        });
    }
    /** @returns The row variant to use in the plagiarism overview table for this case. */
    get _rowVariant() {
        if (!this.canSeeDetails) {
            return 'warning';
        }
        return undefined;
    }
}
__decorate([
    CacheDecorator.cache
], PlagiarismCase.prototype, "storeUsers", null);
